'use client'

import { lazy, Suspense, useEffect, useState } from 'react'
import type { EditorProps } from './editor.types'

// Lazy load the editor content to prevent SSR issues
const EditorContent = lazy(() => import('./editor.content'))

function EditorLoading() {
  return (
    <div className='h-40 w-full animate-pulse rounded-md bg-neutral-surface-5' />
  )
}

export function Editor(props: EditorProps) {
  const [isMounted, setIsMounted] = useState(false)

  useEffect(() => {
    setIsMounted(true)
  }, [])

  // Don't render on server side
  if (!isMounted) {
    return <EditorLoading />
  }

  return (
    <Suspense fallback={<EditorLoading />}>
      <EditorContent {...props} />
    </Suspense>
  )
}
